import * as types from "../types";

export const getCertificates = ({ page, perPage, courseIdFilter }) => {
  const request = {
    type: types.GET_CERTIFICATES,
    request: {
      url: "/certificates",
      method: "GET",
      params: {
        page,
        per_page: perPage,
        "q[course_id_eq]": courseIdFilter
      }
    }
  };
  if (page && parseInt(page, 10) !== 1) {
    request.meta = {
      mutations: {
        [types.GET_CERTIFICATES]: (oldData, newData) => {
          if (newData.meta.current_page <= oldData.meta.current_page) return newData;
          return { certificates: oldData.certificates.concat(newData.certificates) };
        }
      }
    };
  }
  return request;
};
